module.exports = __webpack_public_path__ + "static/media/cu-awards.7d638827.png";